import { redrawProjectAction } from 'pages/ChartEditorPage/actions/chartEditor';
import React from 'react';
import { useDispatch } from 'react-redux';
import IconButton from 'shared/buttons/IconButton';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';
import { GenericInputProps } from 'shared/types/commonPropTypes';
import FieldContainer from './FieldContainer';

export default (props: Partial<GenericInputProps & { icon?: string; onClick?: () => void }>) => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(redrawProjectAction({}));
  };
  return (
    <FieldContainer label={props.label} className={'bg-ev-navy-blue-2 text-white'}>
      <IconButton
        icon={props.icon ?? 'play'}
        onClick={props.onClick ?? onClick}
        className="rounded-full w-[24px] h-[24px] shrink-0"
        iconClass="pl-[2px]"
        buttonColor={ButtonColor.White}
      />
    </FieldContainer>
  );
};
